function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Fragment as _Fragment, withDirectives as _withDirectives, mergeProps as _mergeProps, vShow as _vShow, createVNode as _createVNode } from "vue";
import { ref, watch, provide, Teleport, nextTick, computed, onMounted, Transition, onActivated, onDeactivated, defineComponent } from "vue";
import { popupSharedProps } from "./shared";
import { isDef, extend, makeStringProp, callInterceptor, createNamespace, HAPTICS_FEEDBACK } from "../utils";
import { useEventListener } from "@vant/use";
import { useExpose } from "../composables/use-expose";
import { useLockScroll } from "../composables/use-lock-scroll";
import { useLazyRender } from "../composables/use-lazy-render";
import { POPUP_TOGGLE_KEY } from "../composables/on-popup-reopen";
import { Icon } from "../icon";
import { Overlay } from "../overlay";
var popupProps = extend({}, popupSharedProps, {
  round: Boolean,
  position: makeStringProp("center"),
  closeIcon: makeStringProp("cross"),
  closeable: Boolean,
  transition: String,
  iconPrefix: String,
  closeOnPopstate: Boolean,
  closeIconPosition: makeStringProp("top-right"),
  safeAreaInsetTop: Boolean,
  safeAreaInsetBottom: Boolean
});

var _createNamespace = createNamespace("popup"),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

var globalZIndex = 2e3;
var stdin_default = defineComponent({
  name: name,
  inheritAttrs: false,
  props: popupProps,
  emits: ["open", "close", "opened", "closed", "keydown", "update:show", "click-overlay", "click-close-icon"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
        attrs = _ref.attrs,
        slots = _ref.slots;
    var opened;
    var shouldReopen;
    var zIndex = ref();
    var popupRef = ref();
    var lazyRender = useLazyRender(function () {
      return props.show || !props.lazyRender;
    });
    var style = computed(function () {
      var style2 = {
        zIndex: zIndex.value
      };

      if (isDef(props.duration)) {
        var key = props.position === "center" ? "animationDuration" : "transitionDuration";
        style2[key] = "".concat(props.duration, "s");
      }

      return style2;
    });

    var open = function open() {
      if (!opened) {
        if (props.zIndex !== void 0) {
          globalZIndex = +props.zIndex;
        }

        opened = true;
        zIndex.value = ++globalZIndex;
        emit("open");
      }
    };

    var close = function close() {
      if (opened) {
        callInterceptor(props.beforeClose, {
          done: function done() {
            opened = false;
            emit("close");
            emit("update:show", false);
          }
        });
      }
    };

    var onClickOverlay = function onClickOverlay(event) {
      emit("click-overlay", event);

      if (props.closeOnClickOverlay) {
        close();
      }
    };

    var renderOverlay = function renderOverlay() {
      if (props.overlay) {
        return _createVNode(Overlay, {
          "show": props.show,
          "class": props.overlayClass,
          "zIndex": zIndex.value,
          "duration": props.duration,
          "customStyle": props.overlayStyle,
          "onClick": onClickOverlay
        }, {
          "default": slots["overlay-content"]
        });
      }
    };

    var onClickCloseIcon = function onClickCloseIcon(event) {
      emit("click-close-icon", event);
      close();
    };

    var renderCloseIcon = function renderCloseIcon() {
      if (props.closeable) {
        return _createVNode(Icon, {
          "role": "button",
          "tabindex": 0,
          "name": props.closeIcon,
          "class": [bem("close-icon", props.closeIconPosition), HAPTICS_FEEDBACK],
          "classPrefix": props.iconPrefix,
          "onClick": onClickCloseIcon
        }, null);
      }
    };

    var onOpened = function onOpened() {
      return emit("opened");
    };

    var onClosed = function onClosed() {
      return emit("closed");
    };

    var onKeydown = function onKeydown(event) {
      return emit("keydown", event);
    };

    var renderPopup = lazyRender(function () {
      var _a;

      var round = props.round,
          position = props.position,
          safeAreaInsetTop = props.safeAreaInsetTop,
          safeAreaInsetBottom = props.safeAreaInsetBottom;
      return _withDirectives(_createVNode("div", _mergeProps({
        "ref": popupRef,
        "style": style.value,
        "class": [bem(_defineProperty({
          round: round
        }, position, position)), {
          "van-safe-area-top": safeAreaInsetTop,
          "van-safe-area-bottom": safeAreaInsetBottom
        }],
        "onKeydown": onKeydown
      }, attrs), [(_a = slots["default"]) == null ? void 0 : _a.call(slots), renderCloseIcon()]), [[_vShow, props.show]]);
    });

    var renderTransition = function renderTransition() {
      var position = props.position,
          transition = props.transition,
          transitionAppear = props.transitionAppear;
      var name2 = position === "center" ? "van-fade" : "van-popup-slide-".concat(position);
      return _createVNode(Transition, {
        "name": transition || name2,
        "appear": transitionAppear,
        "onAfterEnter": onOpened,
        "onAfterLeave": onClosed
      }, {
        "default": renderPopup
      });
    };

    watch(function () {
      return props.show;
    }, function (show) {
      if (show && !opened) {
        open();

        if (attrs.tabindex === 0) {
          nextTick(function () {
            var _a;

            (_a = popupRef.value) == null ? void 0 : _a.focus();
          });
        }
      }

      if (!show && opened) {
        opened = false;
        emit("close");
      }
    });
    useExpose({
      popupRef: popupRef
    });
    useLockScroll(popupRef, function () {
      return props.show && props.lockScroll;
    });
    useEventListener("popstate", function () {
      if (props.closeOnPopstate) {
        close();
        shouldReopen = false;
      }
    });
    onMounted(function () {
      if (props.show) {
        open();
      }
    });
    onActivated(function () {
      if (shouldReopen) {
        emit("update:show", true);
        shouldReopen = false;
      }
    });
    onDeactivated(function () {
      if (props.show) {
        close();
        shouldReopen = true;
      }
    });
    provide(POPUP_TOGGLE_KEY, function () {
      return props.show;
    });
    return function () {
      if (props.teleport) {
        return _createVNode(Teleport, {
          "to": props.teleport
        }, {
          "default": function _default() {
            return [renderOverlay(), renderTransition()];
          }
        });
      }

      return _createVNode(_Fragment, null, [renderOverlay(), renderTransition()]);
    };
  }
});
export { stdin_default as default };